import { Navigate, useParams } from 'react-router-dom';

import { useGetnap } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import SaveNaps from '../../shared/saveNaps/saveNaps';
import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';

export interface UpdateNapsPageInterface {}

const UpdateNapsPage: React.FC<UpdateNapsPageInterface> = () => {
  
  useCheckPermissions(PermissionsEnum.api_change_nap)
  const { id } = useParams();
  const { data, isLoading } = useGetnap(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_nap) return <Navigate to={ROUTER_PATHS.configuracionRED.napsNav} />;

  return <SaveNaps titlePage={`Editar NAP - ${data?.data?.nombre || "..."}`} editNaps={data.data} />;
};

export default UpdateNapsPage;
